module.exports = __webpack_public_path__ + "media/images/soar/site/bg_works-902df746e29b07ba5e7a12a6952bb871.svg";